import { bool, func, string } from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import ConfirmModal from '../../../../Base/Modal/ConfirmModal';
import Tooltip from '../../../../Base/Tooltip/Tooltip';

const SessionCandidateTooltip = ({
  appointmentId,
  sessionId,
  isCancellableByClient,
  hasAdmissionForm,
  onCancelAppointment,
  onResendConfirmationEmail,
}) => {
  const { t } = useTranslation();

  const [isModalOpened, setIsModalOpened] = useState(false);

  const handleCancelAppointment = () => {
    setIsModalOpened(true);
  };

  // If no actions available then display nothing
  if (!hasAdmissionForm && !isCancellableByClient) {
    return '';
  }

  return (
    <Tooltip position={'bottom-left'} icon={'ellipsis'} width={'325px'}>
      {hasAdmissionForm && (
        <button
          type="button"
          onClick={() => {
            onResendConfirmationEmail(appointmentId);
          }}
          aria-label={`${t('account.sessions.candidate.send-recap-email')} button`}
        >
          <Trans>account.sessions.candidate.send-recap-email</Trans>
        </button>
      )}
      {isCancellableByClient && (
        <Fragment>
          <button
            type="button"
            onClick={handleCancelAppointment}
            aria-label={`${t('account.sessions.candidate.cancel-candidate')} button`}
          >
            <Trans>account.sessions.candidate.cancel-candidate</Trans>
          </button>
          <ConfirmModal
            isOpen={isModalOpened}
            title={t('account.sessions.candidate.cancel-candidate-modal-title')}
            onClose={() => setIsModalOpened(false)}
            buttons={[
              {
                label: t('common.refuse'),
                className: 'button--transparent-light',
                onClick: () => setIsModalOpened(false),
              },
              {
                label: t('common.accept'),
                onClick: () => {
                  setIsModalOpened(false);
                  onCancelAppointment(sessionId, appointmentId);
                },
              },
            ]}
          >
            <Trans>account.sessions.candidate.cancel-candidate-modal-text</Trans>
          </ConfirmModal>
        </Fragment>
      )}
    </Tooltip>
  );
};

SessionCandidateTooltip.propTypes = {
  appointmentId: string.isRequired,
  reFetchCandidates: func,
  isCancellableByClient: bool,
  hasAdmissionForm: bool,
};

export default SessionCandidateTooltip;
